export const environment = {
  production: false,
  okta: {
    issuer: 'https://myappstest.halliburton.com/oauth2/ausk4axfvsdNLJ8rU0h7',
    clientId: '0oa1bwohrkxrcTDwC0h8',
    redirectUri: 'https://dev.iktva.halliburton.com/implicit/callback',
    postLogoutRedirectUri: 'https://dev.iktva.halliburton.com/',
    scopes: ['openid', 'profile', 'email'],
  },
};
